module.exports = __webpack_public_path__ + "img/progateJS.cd00e97d.webp";